import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-524eca88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "page",
  class: "page"
}
const _hoisted_2 = { class: "top white" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h2",
  id: "font-size"
}, "Roxe Careers", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h5",
  id: "font-size"
}, " We believe that blockchain technology and decentralized finance have the ability to create equality of assets, which will lead to equality for people. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_r_button = _resolveComponent("r-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "white" })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_r_button, {
        onClick: _ctx.toJob,
        class: "mb150",
        type: "primary",
        id: "font-size"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Current Openings")
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 512), [
      [_vShow, _ctx.show]
    ])
  ], 512))
}